import { IconButton } from "@livingmap/hippo";
import classNames from "classnames";
import { FC, ReactNode } from "react";

import styles from "./SideSheet.module.scss";

interface Props {
  dataQA: string;
  className?: string;
  title: string;
  children: ReactNode;
  footer: ReactNode;
  onClose: () => void;
}

const SideSheet: FC<Props> = ({
  dataQA,
  className,
  title,
  children,
  footer,
  onClose,
}) => {
  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      <div className={styles.header}>
        <span>{title}</span>
        <IconButton
          dataQA="side-sheet-close-button"
          icon="close"
          iconSize={24}
          size="regular"
          type="primary"
          onClick={onClose}
        />
      </div>
      <div className={styles.content}>{children}</div>
      <div className={styles.footer}>{footer}</div>
    </div>
  );
};

export default SideSheet;
